/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.13",
    versionName: "0.2.0-nightly.2025.12.13",
    versionChannel: "nightly",
    buildDate: "2025-12-13T00:08:25.227Z",
    commitHash: "82aad07b10e438682b546dd8a6fbf638cb7343ca",
};
